import { useWhiteLabelContext } from 'components/white-label';
import { Organization } from 'lib/types/company';
import Script from 'next/script';
import { useEffect } from 'react';

interface IGoogleAnalyticsProps {
  companyId?: number;
  userId?: number;
}

/**
 * Google Analytics component.
 *
 * Relies on the `window.dataLayer` object to push data to Google Analytics.
 * If removing this file, or updating the implementation, make sure to update the `window.d.ts` file to reflect the changes.
 */
export const GoogleAnalytics = ({
  companyId,
  userId,
}: IGoogleAnalyticsProps) => {
  const { organization } = useWhiteLabelContext();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    if (companyId || userId) {
      window.dataLayer.push({ company_id: companyId, user_id: userId });
    }
  }, [companyId, userId]);

  switch (organization) {
    case Organization.LIFE_LABS:
      return (
        <>
          <Script id="google-analytics-lifelabs" strategy="afterInteractive">
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-TLS4XWFV');`}
          </Script>
          <noscript>
            <iframe
              src="https://www.googletagmanager.com/ns.html?id=GTM-TLS4XWFV"
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}
            ></iframe>
          </noscript>
        </>
      );
    case Organization.ETHENA:
    default:
      return (
        <>
          <Script
            src="https://www.googletagmanager.com/gtag/js?id=G-S83ZKEGL8Q"
            strategy="afterInteractive"
          />
          <Script id="google-analytics-ethena" strategy="afterInteractive">
            {`window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date()); gtag('config', 'G-S83ZKEGL8Q');`}
          </Script>
        </>
      );
  }
};
